import React from 'react';
import { NavigationStepperItemType } from '../NavigationStepper';
import { joinClasses } from '../../../Utils/className.util';
import Text from '../../Base/Text/Text';
import { NavigationStepperItemProps } from '../NavigationStepperItem';

// @ts-ignore
import styles from './TabNavigationStepperItem.module.scss';

const TabNavigationStepperItem: React.FC<
	NavigationStepperItemProps
> = props => {
	const { item, onChange, activeKey } = props;

	return (
		<div
			className={joinClasses([
				styles.item,
				activeKey === item.key && styles.active,
				item.disabled && styles.disabled,
			])}
			onClick={() => onChange(item)}>
			{item?.icon && (
				<div className={styles.iconWrapper}>
					<img src={item?.icon} />
				</div>
			)}
			<div className={styles.title}>
				<Text tx={item.name} inline={true} />
			</div>
		</div>
	);
};

export default TabNavigationStepperItem;
